<template>
    <div class="doc_sb_edit p-3">
        <b-overlay  :show="is_load" rounded="sm">
            <div class="form-group mt-2">
                <label class="form-label" for="advanced_type">
                    Тип
                </label>
                <div class="input-group flex-nowrap">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="fal fa-typewriter fs-xl"></i>
                        </span>
                    </div>
                    <input id="advanced_type" disabled type="text" class="form-control" :value="typeLabel">
                </div>
            </div>
            
            <div class="form-group mt-2">
                <label class="form-label" for="advanced_state">
                    Статус
                </label>
                <div class="input-group flex-nowrap">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="fal fa-typewriter fs-xl"></i>
                        </span>
                    </div>
                    <input id="advanced_state" disabled type="text" class="form-control" :value="stateLabel">
                </div>
            </div>
            
            <div class="form-group mt-2">
                <label class="form-label" for="advanced_created">
                    Створено
                </label>
                <div class="input-group flex-nowrap">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="fal fa-typewriter fs-xl"></i>
                        </span>
                    </div>
                    <input id="advanced_created" disabled type="text" class="form-control" :value="createdAtLabel">
                </div>
            </div>
            
            <div class="list_state mt-4" v-if="has_action">
                <div class="form-group mt-2">
                    <label class="form-label" for="intro_html">
                        План врегулювання
                    </label>
                    
                    <div class="input-group flex-nowrap d-block">
                        <vue-editor :editor-toolbar="editor_rules"  v-model="doc.settlement_plan"></vue-editor>
                    </div>
                    
                    <button type="button" v-on:click="save_settlement" class="mt-4 btn btn-primary waves-effect waves-themed">
                        Зберегти
                    </button>
                </div>
            </div>
        </b-overlay>
        
    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
    name: "doc_svk",
    props: {
        doc: {
            type: Object,
            default: () => ({})
        }
    },
    
    data() {
        return {
            editor_rules :[
                ["bold", "italic", "underline","link"],
                [{ align: "center" }, { align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
            ],
            is_load: false,
        }
    },
    
    methods : {
        async save_settlement() {
            this.is_load = true;
            await api.put('/declaration/' + this.doc.id + "/settlement", {
                declaration: this.doc,
            }).then(({data}) => {
                EventBus.$emit('show_toast', { err: 'Відправлено', type: "success", title: 'OK' });
            
            }).catch(err => {
                this.is_load = false;
                console.log(err);
                if (err.response && err.response.hasOwnProperty('data')) {
                    EventBus.$emit('show_toast', {
                        err: err.response.data.message,
                        type: "danger",
                        title: err.response.data.status
                    });
                } else {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                }
            })
                .finally(() => {
                    IMC_CORE.hideloading();
                    this.is_load = false;
                });
        },
    },
    
    
    computed: {
        
        svk() {
            return this.doc.svk || {
                "has_action": false,
            };
        },
        
        has_action() {
            return this.svk.has_action;
        },
        
        typeLabel() {
            if (this.doc.type === 'year') return 'Щорічна';
            if (this.doc.type === 'ad-hoc') return 'Ситуативна (Ad-hoc)';
            return this.doc.type || '';
        },
        
        stateLabel() {
            if (this.doc.state === 'green') return 'Зелений';
            if (this.doc.state === 'yellow') return 'Жовтий';
            if (this.doc.state === 'red') return 'Червоний';
            return this.doc.state || '';
        },
        
        createdAtLabel() {
            if (!this.doc.created_at) {
                return '';
            }
            
            return new Date(this.doc.created_at).toLocaleString('uk-UA');
        }
    }
}
</script>

<style scoped>
</style>